document.addEventListener("DOMContentLoaded", function() {

    const isInViewport = (el) => {
        let bounding = el.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    // vizualni pricitani cisel
    //=========================
    const incrementNumbers = () => {
        let numbers = document.querySelectorAll('.JS-number');
        if (numbers.length === 0)
            return;

        numbers.forEach((el) => {
            if(!isInViewport(el) || el.classList.contains('JS-numberIncremented'))
                return;

            el.classList.add('JS-numberIncremented');
            animJs.number(el);
        });
    };

    incrementNumbers();

    window.addEventListener('scroll', incrementNumbers);
    window.addEventListener('resize', incrementNumbers);
    window.addEventListener('orientationchange', incrementNumbers);


    let locNemovitost = document.querySelector('.location_nemovitost');
    if(typeof(locNemovitost) != 'undefined' && locNemovitost != null){
        (function () {
            let links = document.querySelectorAll('.JS-estateDetail-link');
            links.forEach(function (el) {
                el.addEventListener("click", function (e) {
                    e.preventDefault();

                    links.forEach(function (link) {
                        link.classList.remove('active');
                    });
                    el.classList.add('active');

                    document.querySelectorAll('.JS-estateDetail-tab').forEach(function (tab) {
                        tab.classList.remove('estateDetail-tab--active');
                    });

                    if (el.classList.contains('estateDetail-link--image'))
                        document.querySelector('.estateDetail-tab--image').classList.add('estateDetail-tab--active');
                    else if(el.classList.contains('estateDetail-link--video'))
                        document.querySelector('.estateDetail-tab--video').classList.add('estateDetail-tab--active');
                    else
                        document.querySelector('.estateDetail-tab--streetView').classList.add('estateDetail-tab--active');
                });
            });
        }());
    }
});